import BaseItemView from 'app/src/views/base/BaseItemView';
import $ from 'jquery';
import modalFooterTemplate from './templates/modal-footer-view.hbs';

let _Events = {
  MODAL_FOOTER_BUTTON_CLICKED: 'modal:footer:button:clicked',
};

// configure
let View = BaseItemView.extend({
  template: modalFooterTemplate,

  ui: {
    button: '.modal-button',
  },

  events: {
    'click @ui.button': 'onButtonClicked',
  },
});

// define
export default class ModalFooterView extends View {
  /**
   * Event handler for when a button is clicked.  The method will trigger an event with the id
   * of the button that was clicked.
   *
   * @param {Event} event  The triggering DOM event
   */
  onButtonClicked(event) {
    let $button = $(event.target);

    if ($button.length) {
      this.trigger(_Events.MODAL_FOOTER_BUTTON_CLICKED, $button.attr('buttonID'));
    }
  }
}
